import { VStack, Image, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface CommentsDisabledLargeProps {
  height?: string;
  showBackground?: boolean;
}

export function CommentsDisabledLarge({ 
  height = "229px",
  showBackground = false
}: CommentsDisabledLargeProps) {
  const { t } = useTranslation();

  return (
    <VStack 
      spacing="12px" 
      py="24px" 
      height={height}
      justifyContent="center"
      bg={showBackground ? "transparent.white.05" : "transparent"}
      borderRadius={showBackground ? "16px" : "0"}
    >
      <Image
        src="/static/images/web-ui/comments_off.svg"
        alt="Comments disabled"
        boxSize="96px"
      />
      <Text
        fontSize="18px"
        color="neutral.300"
        textAlign="center"
        fontWeight="500"
      >
        {t("screens.reader.commentsMenu.commentsDisabled")}
      </Text>
    </VStack>
  );
}